import { render } from "./GoodMedicationsSubtypes.vue?vue&type=template&id=5f3751ca"
import script from "./GoodMedicationsSubtypes.vue?vue&type=script&lang=js"
export * from "./GoodMedicationsSubtypes.vue?vue&type=script&lang=js"

import "./GoodMedicationsSubtypes.vue?vue&type=style&index=0&id=5f3751ca&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__